/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedPagination_buyPage = {
    readonly displayMaxNumberOfPages: number | null;
    readonly " $refType": "BuySharedPagination_buyPage";
};
export type BuySharedPagination_buyPage$data = BuySharedPagination_buyPage;
export type BuySharedPagination_buyPage$key = {
    readonly " $data"?: BuySharedPagination_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedPagination_buyPage">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedPagination_buyPage",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayMaxNumberOfPages",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '06c81c3cfb0e228eae91f74392267e5a';
export default node;
